import React from 'react';
import http from "./../../../services/httpService";
import 'react-circular-progressbar/dist/styles.css';
import {CChart} from "@coreui/react-chartjs";

import "bootstrap-daterangepicker/daterangepicker.css";
import '@coreui/chartjs/scss/coreui-chartjs.scss';
import Emitter from '../../../services/Emitter';
import Squre from "../../../components/skelete/Squre";
import SkeleteLoading from "../../../components/SkeleteLoading";


class CashData extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loadingForm: true,
            to: this.props.t,
            from: this.props.f,
            cashChart:false,
        }

    }

    getCashData=()=>{
        http.post('dashboard/get/cash-data',{from:this.state.from,to:this.state.to})
            .then(response => {
                this.setState({
                    loadingForm: false,
                    cashChart:response.data.cashChart,
                });
            });
    }


    componentDidMount() {
        Emitter.on('reloadData', () => this.getCashData());
    }

    componentWillUnmount() {
        Emitter.off('reloadData');
    }

    render() {

        return (
            this.state.loadingForm ?
                <SkeleteLoading>
                    <div className=" mt-4">
                        <Squre height={300}/>
                    </div>
                </SkeleteLoading>
                :
                <React.Fragment>
                    <div className="card card-body dashboard-rr chart-data mt-4">
                        <div className="card-title">نقد درآمد</div>
                        {this.state.cashChart?
                            <CChart
                                height={90}
                                type="line"
                                data={{
                                    labels: this.state.cashChart.all.label,
                                    datasets: [
                                        {
                                            label: this.state.cashChart.all.title,
                                            backgroundColor: "rgba(220, 220, 220, 0.2)",
                                            borderColor: "rgba(56,38,4,0.51)",
                                            pointBackgroundColor: "rgb(44,27,3)",
                                            pointBorderColor: "#fff",
                                            data: this.state.cashChart.all.data
                                        },
                                        {
                                            label: this.state.cashChart.done.title,
                                            backgroundColor: "rgba(220, 220, 220, 0.2)",
                                            borderColor: "rgba(40,182,8,0.51)",
                                            pointBackgroundColor: "rgb(52,182,8)",
                                            pointBorderColor: "#fff",
                                            data: this.state.cashChart.done.data
                                        },
                                        {
                                            label: this.state.cashChart.cancel.title,
                                            backgroundColor: "rgba(220, 220, 220, 0.2)",
                                            borderColor: "rgba(208,3,3,0.51)",
                                            pointBackgroundColor: "rgb(203,12,12)",
                                            pointBorderColor: "#fff",
                                            data: this.state.cashChart.cancel.data
                                        },
                                        {
                                            label: this.state.cashChart.other.title,
                                            backgroundColor: "rgba(220, 220, 220, 0.2)",
                                            borderColor: "rgba(8,69,182,0.51)",
                                            pointBackgroundColor: "rgb(8,49,182)",
                                            pointBorderColor: "#fff",
                                            data: this.state.cashChart.other.data
                                        }
                                    ],
                                }}
                            />
                            :''}
                    </div>
                </React.Fragment>

        )
    }

}

export default CashData;
